import { UserRolesType } from '../../components/LoginForm/types';
import { useAppSelector } from '../../reducers/rootReducer';

const useUserRole = (role: UserRolesType) => {
  const { userRoles } = useAppSelector((state) => state.userSession);
  return userRoles?.includes(role);
};

export default useUserRole;
